import React, { useLayoutEffect, useRef } from 'react'

import * as bulkOrderSelectors from 'customizer/bulkOrder/selectors'
import { stepIsAvailable } from 'customizer/customization/utils'
import { useSelector } from 'customizer/hooks'
import BulkOrderEmptyQuantity from 'themes/common/components/bulkOrder/BulkOrderEmptyQuantity'

import BulkOrderList from './BulkOrderList'
import BulkOrderStepHeader from './BulkOrderStepHeader'

import './BulkOrderDrawer.scss'

const BulkOrderDrawer = () => {
  const firstRender = useRef(true)
  const bulkOrderGroup = useSelector(bulkOrderSelectors.bulkOrderDenormalizedGroupSelector)!
  const bulkOrderRows = useSelector(bulkOrderSelectors.denormalizedBulkOrderQuestionsSelector)
  const shownRow = useSelector(bulkOrderSelectors.bulkOrderTableShownRowSelector)
  const showTopBorder = shownRow != null && (shownRow + 1 === bulkOrderRows.length || bulkOrderRows.length === 1)

  useLayoutEffect(() => {
    if (!firstRender.current && shownRow != null) {
      setTimeout(() => {
        const rowElement = document.getElementById(`bulk-order-row-${shownRow}`)

        if (rowElement) {
          const { top, bottom } = rowElement.getBoundingClientRect()
          const isFirstQuestionVisible = bottom <= window.innerHeight - 200
          const isTopVisible = top > 0

          if (!isFirstQuestionVisible || !isTopVisible) {
            rowElement?.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }
      }, 550)
    }

    firstRender.current = false
  }, [shownRow])

  return (
    <>
      {stepIsAvailable(bulkOrderGroup) ? (
        <>
          <BulkOrderStepHeader bulkOrder={bulkOrderGroup} />
          <BulkOrderList bulkOrderGroup={bulkOrderGroup} rows={bulkOrderRows} showTopBorder={showTopBorder} />
        </>
      ) : (
        <BulkOrderEmptyQuantity bulkOrderGroup={bulkOrderGroup} />
      )}
    </>
  )
}

export default BulkOrderDrawer
